import { lazy } from 'react';
import { ROUTES } from '@/constants';

const LandingPage = lazy(() => import('@/pages/LandingPage'));
const DashboardPage = lazy(() => import('@/pages/dashboard/DashboardPage'));
const PillarChairDashboardPage = lazy(() => import('@/pages/pillarChair/PillarChairDashboardPage'));
const ProjectDetailPage = lazy(() => import('@/pages/pillarChair/ProjectDetailPage'));
const ApprovedPage = lazy(() => import('@/pages/pillarChair/ApprovedPage'));
const PillarChairMembersPage = lazy(() => import('@/pages/pillarChair/PillarChairMembersPage'));
const PillarChairProjectsPage = lazy(() => import('@/pages/pillarChair/PillarChairProjectsPage'));
const PillarChairProjectManagersPage = lazy(() => import('@/pages/pillarChair/PillarChairProjectManagersPage'));
const PillarChairLocationsPage = lazy(() => import('@/pages/pillarChair/PillarChairLocationsPage'));
const ProjectManagerDashboardPage = lazy(() => import('@/pages/projectManager/ProjectManagerDashboardPage'));
const ProjectManagementEntryPage = lazy(() => import('@/pages/projectManager/ProjectManagementEntryPage'));
const ProjectManagementPage = lazy(() => import('@/pages/projectManager/ProjectManagementPage'));
const ProjectManagerTasksPage = lazy(() => import('@/pages/projectManager/ProjectManagerTasksPage'));
const ProjectManagerTaskDetailPage = lazy(() => import('@/pages/projectManager/ProjectManagerTaskDetailPage'));
const EscalationHistoryPage = lazy(() => import('@/pages/shared/EscalationHistoryPage'));
const MemberDashboardPage = lazy(() => import('@/pages/member/MemberDashboardPage'));
const MemberTasksPage = lazy(() => import('@/pages/member/MemberTasksPage'));
const TaskDetailPage = lazy(() => import('@/pages/member/TaskDetailPage'));
const TaskForceChairDashboardPage = lazy(() => import('@/pages/leadership/TaskForceChairDashboardPage'));
const TaskForceChairPillarsPage = lazy(() => import('@/pages/leadership/TaskForceChairPillarsPage'));
const TaskForceChairPillarDetailPage = lazy(() => import('@/pages/leadership/TaskForceChairPillarDetailPage'));
const ExecutiveDashboardPage = lazy(() => import('@/pages/leadership/ExecutiveDashboardPage'));
const ExecTaskForceDetailPage = lazy(() => import('@/pages/leadership/ExecTaskForceDetailPage'));
const ExecPillarDetailPage = lazy(() => import('@/pages/leadership/ExecPillarDetailPage'));
const AdminDashboardPage = lazy(() => import('@/pages/leadership/AdminDashboardPage'));
const AdminTaskForcesPage = lazy(() => import('@/pages/leadership/AdminTaskForcesPage'));
const AdminUsersPage = lazy(() => import('@/pages/leadership/AdminUsersPage'));
const AdminAccountManagementPage = lazy(() => import('@/pages/admin/AdminAccountManagementPage'));
const AdminRoleManagementPage = lazy(() => import('@/pages/leadership/AdminRoleManagementPage'));
const AdminCitiesPage = lazy(() => import('@/pages/leadership/AdminCitiesPage'));
const AdminOrganizationsPage = lazy(() => import('@/pages/admin/AdminOrganizationsPage'));
const AuditLogsPage = lazy(() => import('@/pages/admin/AuditLogsPage'));
const NotFoundPage = lazy(() => import('@/pages/errors/NotFoundPage'));
const SettingsPage = lazy(() => import('@/pages/settings/SettingsPage'));
const UserManualPage = lazy(() => import('@/pages/help/UserManualPage'));
const WeeklyActivityReportPage = lazy(() => import('@/pages/reports/WeeklyActivityReportPage'));
const ExportPage = lazy(() => import('@/pages/export/ExportPage'));
const StructurePage = lazy(() => import('@/pages/shared/StructurePage'));


const TaskForceChairPillarChairsPage = lazy(() => import('@/pages/leadership/TaskForceChairPillarChairsPage'));

const AdminTaskForceChairsPage = lazy(() => import('@/pages/admin/AdminTaskForceChairsPage'));
const AdminExecutivesPage = lazy(() => import('@/pages/admin/AdminExecutivesPage'));
const AdminAdministratorsPage = lazy(() => import('@/pages/admin/AdminAdministratorsPage'));
const NotificationManagementPage = lazy(() =>
    import('@/pages/admin/NotificationManagementPage'),
);
const AutoEscalationPage = lazy(() => import('@/pages/admin/AutoEscalationPage'));
const CountdownManagementPage = lazy(() =>
    import('@/pages/admin/CountdownManagementPage'),
);
const AdminOperationalIndicatorsPage = lazy(() =>
    import('@/pages/admin/AdminOperationalIndicatorsPage'),
);
const AdminRegistrationConfirmationPage = lazy(() =>
    import('@/pages/admin/AdminRegistrationConfirmationPage'),
);
const MyRegistrationConfirmationPage = lazy(() =>
    import('@/pages/projectManager/MyRegistrationConfirmationPage'),
);
const AdminOperationalDashboardViewersPage = lazy(() =>
    import('@/pages/admin/AdminOperationalDashboardViewersPage'),
);
const OperationalDashboardPage = lazy(() =>
    import('@/pages/shared/OperationalDashboardPage'),
);
const MyOperationalIndicatorsPage = lazy(() =>
    import('@/pages/projectManager/MyOperationalIndicatorsPage'),
);
const AdminPillarsPage = lazy(() => import('@/pages/admin/AdminPillarsPage'));
const AdminProjectsPage = lazy(() => import('@/pages/admin/AdminProjectsPage'));
const AdminTasksPage = lazy(() => import('@/pages/admin/AdminTasksPage'));
const AdminTaskDetailPage = lazy(() => import('@/pages/admin/AdminTaskDetailPage'));
const AdminImportHubPage = lazy(() => import('@/pages/admin/AdminImportHubPage'));
const AdminImportUsersPage = lazy(() => import('@/pages/admin/AdminImportUsersPage'));
const AdminImportOrganizationsPage = lazy(() => import('@/pages/admin/AdminImportOrganizationsPage'));
const AdminImportTasksPage = lazy(() => import('@/pages/admin/AdminImportTasksPage'));


export const settingsRoutes = [
    { path: 'settings', element: SettingsPage },
    { path: 'settings/profile', element: SettingsPage },
    { path: 'settings/security', element: SettingsPage },
];

export const publicRoutes = [
    { path: ROUTES.HOME, element: LandingPage },
];

export const dashboardRoutes = [
    { path: ROUTES.DASHBOARD, element: DashboardPage },
    { path: 'export', element: ExportPage },
    { path: 'structure', element: StructurePage },
    { path: 'help', element: UserManualPage },
    ...settingsRoutes,
];



export const memberRoutes = [
    { index: true, element: MemberDashboardPage },
    { path: 'structure', element: StructurePage },
    { path: 'help', element: UserManualPage },
    { path: 'tasks', element: MemberTasksPage },
    { path: 'tasks/:id', element: TaskDetailPage },
    { path: 'escalation-history', element: EscalationHistoryPage },
    ...settingsRoutes,
];

export const pillarChairRoutes = [
    { index: true, element: PillarChairDashboardPage },
    { path: 'weekly-report', element: WeeklyActivityReportPage },
    { path: 'export', element: ExportPage },
    { path: 'structure', element: StructurePage },
    { path: 'help', element: UserManualPage },
    { path: 'projects/:projectId/task/:taskId', element: ProjectManagerTaskDetailPage },
    { path: 'projects/:projectId', element: ProjectDetailPage },
    { path: 'projects', element: PillarChairProjectsPage },
    { path: 'approved', element: ApprovedPage },
    { path: 'locations', element: PillarChairLocationsPage },
    { path: 'escalation-history', element: EscalationHistoryPage },
    { path: 'operational-dashboard', element: OperationalDashboardPage },
    ...settingsRoutes,
];

export const projectManagerRoutes = [
    { index: true, element: ProjectManagerDashboardPage },
    { path: 'weekly-report', element: WeeklyActivityReportPage },
    { path: 'export', element: ExportPage },
    { path: 'structure', element: StructurePage },
    { path: 'help', element: UserManualPage },
    { path: 'projects', element: ProjectManagementEntryPage },
    { path: 'projects/:projectId/task/:taskId', element: ProjectManagerTaskDetailPage },
    { path: 'projects/:projectId', element: ProjectDetailPage },
    { path: 'tasks', element: ProjectManagerTasksPage },
    { path: 'tasks/:projectId/:taskId', element: ProjectManagerTaskDetailPage },
    { path: 'tasks/:projectId', element: ProjectDetailPage },
    { path: 'locations', element: PillarChairLocationsPage },
    { path: 'escalation-history', element: EscalationHistoryPage },
    { path: 'operational-indicators', element: MyOperationalIndicatorsPage },
    { path: 'registration-confirmation', element: MyRegistrationConfirmationPage },
    ...settingsRoutes,
];

export const taskForceChairRoutes = [
    { index: true, element: TaskForceChairDashboardPage },
    { path: 'export', element: ExportPage },
    { path: 'structure', element: StructurePage },
    { path: 'help', element: UserManualPage },
    { path: 'pillars', element: TaskForceChairPillarsPage },
    { path: 'pillar/:pillarId', element: TaskForceChairPillarDetailPage },
    { path: 'escalation-history', element: EscalationHistoryPage },
    { path: 'operational-dashboard', element: OperationalDashboardPage },
    ...settingsRoutes,
];

export const executiveRoutes = [
    { index: true, element: ExecutiveDashboardPage },
    { path: 'export', element: ExportPage },
    { path: 'structure', element: StructurePage },
    { path: 'help', element: UserManualPage },
    { path: 'task-force/:tfId', element: ExecTaskForceDetailPage },
    { path: 'task-force/:tfId/:pillarId', element: ExecPillarDetailPage },
    { path: 'operational-dashboard', element: OperationalDashboardPage },
    ...settingsRoutes,
];

export const adminRoutes = [
    { index: true, element: AdminDashboardPage },
    { path: 'export', element: ExportPage },
    { path: 'structure', element: StructurePage },
    { path: 'help', element: UserManualPage },
    { path: 'task-forces', element: AdminTaskForcesPage },
    { path: 'task-force-chairs', element: AdminTaskForceChairsPage },
    { path: 'executives', element: AdminExecutivesPage },
    { path: 'administrators', element: AdminAdministratorsPage },
    { path: 'users', element: AdminUsersPage },
    { path: 'accounts', element: AdminAccountManagementPage },
    { path: 'pillar-chairs', element: TaskForceChairPillarChairsPage },
    { path: 'project-managers', element: PillarChairProjectManagersPage },
    { path: 'members', element: PillarChairMembersPage },

    // Delivery hierarchy: the role management pages, admin-scoped to every
    // task force / pillar / project rather than the caller's own.
    { path: 'pillars', element: AdminPillarsPage },
    { path: 'projects', element: AdminProjectsPage },
    { path: 'tasks', element: AdminTasksPage },
    { path: 'tasks/:projectId/:taskId', element: AdminTaskDetailPage },
    // Reached by the detail page's back link after a refresh drops router state.
    { path: 'tasks/:projectId', element: AdminTasksPage },

    { path: 'roles', element: AdminRoleManagementPage },
    { path: 'cities', element: AdminCitiesPage },
    { path: 'organizations', element: AdminOrganizationsPage },
    { path: 'notification-management', element: NotificationManagementPage },
    { path: 'auto-escalation', element: AutoEscalationPage },
    { path: 'countdown', element: CountdownManagementPage },
    { path: 'operational-indicators', element: AdminOperationalIndicatorsPage },
    { path: 'registration-confirmation', element: AdminRegistrationConfirmationPage },
    { path: 'operational-dashboard-viewers', element: AdminOperationalDashboardViewersPage },
    { path: 'audit-logs', element: AuditLogsPage },
    { path: 'import/users', element: AdminImportUsersPage },
    { path: 'import/organizations', element: AdminImportOrganizationsPage },
    { path: 'import/tasks', element: AdminImportTasksPage },
    { path: 'import', element: AdminImportHubPage },
    ...settingsRoutes,
];

export const errorRoutes = [
    { path: '*', element: NotFoundPage },
];

